import de from '@vueform/vueform/locales/de'
import fr from '@vueform/vueform/locales/fr_CA'
import it from '@vueform/vueform/locales/it'

import {
  Vueform,
  FormElements,

  // Essential form components
  FormErrors,
  FormMessages,

  // Essential element components
  ElementLayout,
  ElementLoader,
  ElementLabelFloating,
  ElementLabel,
  ElementError,
  ElementText,
  ElementDescription,
  ElementMessage,
  ElementInfo,
  ElementRequired,
  ElementAddon,

  // Optional form components
  FormLanguages,
  FormLanguage,
  FormSteps,
  FormStepsControls,
  FormStepsControl,
  FormStep,

  // Elements
  ButtonElement,
  SelectElement,
  SliderElement,
  StaticElement,
  TextElement,
  HiddenElement,
  classes,
  columns
} from '@vueform/vueform/themes/vueform'

// import vueform from '@vueform/vueform/themes/vueform'
import { defineConfig } from '@vueform/vueform/src/core.js'
// You might place these anywhere else in your project
import '@vueform/vueform/dist/vueform.css'

const vueform = {
  templates: {
    Vueform,
    FormElements,

    // Essential form components
    FormErrors,
    FormMessages,

    // Essential element components
    ElementLayout,
    ElementLoader,
    ElementLabelFloating,
    ElementLabel,
    ElementError,
    ElementText,
    ElementDescription,
    ElementMessage,
    ElementInfo,
    ElementRequired,
    ElementAddon,

    // Optional form components
    FormLanguages,
    FormLanguage,
    FormSteps,
    FormStepsControls,
    FormStepsControl,
    FormStep,

    // Elements
    ButtonElement,
    SelectElement,
    SliderElement,
    StaticElement,
    HiddenElement,
    TextElement
  },

  // Include these
  classes,
  columns
}
import {
  accepted,
  active_url,
  after,
  after_or_equal,
  alpha,
  alpha_dash,
  alpha_num,
  array,
  before,
  before_or_equal,
  between,
  boolean,
  captcha,
  completed,
  confirmed,
  date,
  date_equals,
  date_format,
  different,
  digits,
  digits_between,
  dimensions,
  distinct,
  email,
  exists,
  file,
  filled,
  gt,
  gte,
  image,
  in_,
  in_array,
  integer,
  ip,
  ipv4,
  ipv6,
  json,
  lt,
  lte,
  max,
  mimes,
  mimetypes,
  min,
  not_in,
  not_regex,
  nullable,
  numeric,
  regex,
  required,
  same,
  size,
  string,
  timezone,
  unique,
  url,
  uuid
} from '@vueform/vueform/src/core.js'

de.validation.required = 'Das Feld «:attribute» muss ausgefüllt werden.'
fr.validation.required = 'Le champ « :attribute » est obligatoire.'
it.validation.required = 'Il campo «:attribute» è richiesto.'

export default defineConfig({
  theme: vueform,
  rules: {
    required,
    completed,
    email
  },
  locales: { de, fr, it },
  locale: 'de',
  classHelpers: false,
  scrollToInvalid: false
})
